var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", { staticClass: "flex justify-between mb46" }, [
          _c("div", { staticClass: "header_title" }, [_vm._v("用户概况")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "acea-row" },
            [
              _c(
                "div",
                { staticClass: "mr-20" },
                [
                  _c(
                    "el-radio-group",
                    {
                      staticClass: "mr20",
                      attrs: { type: "button", size: "small" },
                      on: { change: _vm.handleSeleteRio },
                      model: {
                        value: _vm.dateLimit,
                        callback: function ($$v) {
                          _vm.dateLimit = $$v
                        },
                        expression: "dateLimit",
                      },
                    },
                    _vm._l(_vm.text, function (item, i) {
                      return _c(
                        "el-radio-button",
                        { key: i, attrs: { label: item.dateLimit } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    staticStyle: { width: "220px", height: "34px" },
                    attrs: {
                      size: "small",
                      type: "daterange",
                      placement: "bottom-end",
                      "value-format": "yyyy-MM-dd",
                      format: "yyyy-MM-dd",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期",
                      align: "right",
                    },
                    on: { change: _vm.onchangeTime },
                    model: {
                      value: _vm.timeVal,
                      callback: function ($$v) {
                        _vm.timeVal = $$v
                      },
                      expression: "timeVal",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "mr10",
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.handleDataList },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "box-tatic-box" }, [
          _c(
            "div",
            { staticClass: "box-echarts-right" },
            _vm._l(_vm.dataRight, function (item, index) {
              return _c("div", { key: index, staticClass: "box-eachar-data" }, [
                _c("div", { staticClass: "box-img-data" }, [
                  _c("img", {
                    staticClass: "box-img-data",
                    attrs: {
                      src: require("@/assets/imgs/dash-" + index + ".png"),
                      alt: "",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "box-text-bootn-data" },
                  [
                    _c("span", { staticClass: "box-text-chine-data" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("countTo", {
                      staticClass: "box-text-num-data",
                      attrs: {
                        startVal: 0,
                        endVal: Number(item.value),
                        duration: 2000,
                      },
                    }),
                  ],
                  1
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "box-data-right" },
            [
              _c(
                "el-select",
                {
                  attrs: { filterable: "", placeholder: "请选择小程序" },
                  on: { change: _vm.handleSeklectEd },
                  model: {
                    value: _vm.selecterVales,
                    callback: function ($$v) {
                      _vm.selecterVales = $$v
                    },
                    expression: "selecterVales",
                  },
                },
                _vm._l(_vm.selectedList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.customerName, value: item.customerId },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _vm.checkPermi(["admin:statistics:product:data"])
          ? _c(
              "div",
              { staticClass: "flex flex-wrap mb20" },
              _vm._l(_vm.list, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "infoBox acea-row mb30" },
                  [
                    _c(
                      "div",
                      { staticClass: "iconCrl mr15", class: item.class },
                      [
                        _c("i", {
                          staticClass: "iconfont",
                          class: item.icon,
                          style: { color: item.color },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "info" }, [
                      _c(
                        "div",
                        { staticClass: "flex align-center" },
                        [
                          _c("span", {
                            staticClass: "sp1",
                            domProps: { textContent: _vm._s(item.name) },
                          }),
                          _vm._v(" "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "pl10",
                              attrs: { effect: "dark", placement: "top-start" },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-warning-outline",
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticStyle: { "max-width": "400px" },
                                attrs: { slot: "content" },
                                domProps: { textContent: _vm._s(item.info) },
                                slot: "content",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      index === _vm.list.length - 1
                        ? _c("span", {
                            staticClass: "sp2",
                            domProps: { textContent: _vm._s(item.list.num) },
                          })
                        : _c("span", {
                            staticClass: "sp2",
                            domProps: { textContent: _vm._s(item.list.num) },
                          }),
                      _vm._v(" "),
                      _c("span", { staticClass: "content-time" }, [
                        _c("i", { class: item.ratio >= 0 ? "up" : "down" }, [
                          _vm._v(_vm._s(item.list.percent)),
                        ]),
                        _vm._v(" "),
                        _c("i", {
                          class:
                            item.ratio >= 0
                              ? "el-icon-caret-top"
                              : "el-icon-caret-bottom",
                          attrs: {
                            color: item.ratio >= 0 ? "#F5222D" : "#39C15B",
                          },
                        }),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "chart-section" }, [
          _c("div", { staticClass: "section-title" }, [
            _c("span", { staticClass: "title-text" }, [_vm._v("页面浏览数据")]),
            _vm._v(" "),
            _c("span", { staticClass: "title-desc" }, [
              _vm._v("展示用户页面浏览趋势"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "chart-container" },
            [
              _vm.optionData &&
              _vm.checkPermi(["admin:statistics:product:trend"])
                ? _c("echarts-new", {
                    attrs: {
                      "option-data": _vm.optionData,
                      styles: _vm.style,
                      height: "100%",
                      width: "100%",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chart-section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _c("span", { staticClass: "title-text" }, [
                _vm._v("用户点击分析"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "title-desc" }, [
                _vm._v("分析用户点击行为和链接访问情况"),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "filter-container" }, [
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("span", { staticClass: "filter-label" }, [
                      _vm._v("链接ID："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入链接ID",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.urlId,
                        callback: function ($$v) {
                          _vm.urlId = $$v
                        },
                        expression: "urlId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("span", { staticClass: "filter-label" }, [
                      _vm._v("链接名："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入链接名称",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.urlName,
                        callback: function ($$v) {
                          _vm.urlName = $$v
                        },
                        expression: "urlName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("span", { staticClass: "filter-label" }, [
                      _vm._v("链接类型："),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "180px" },
                        attrs: {
                          placeholder: "请选择链接类型",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.urlType,
                          callback: function ($$v) {
                            _vm.urlType = $$v
                          },
                          expression: "urlType",
                        },
                      },
                      _vm._l(_vm.urlTypeOptions, function (item) {
                        return _c("el-option", {
                          key: item.key,
                          attrs: { label: item.title, value: item.key },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("span", { staticClass: "filter-label" }, [
                      _vm._v("装修ID："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入装修ID",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.skinId,
                        callback: function ($$v) {
                          _vm.skinId = $$v
                        },
                        expression: "skinId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "filter-item" },
                  [
                    _c("span", { staticClass: "filter-label" }, [
                      _vm._v("装修页面："),
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入装修页面",
                        size: "small",
                        clearable: "",
                      },
                      model: {
                        value: _vm.skinName,
                        callback: function ($$v) {
                          _vm.skinName = $$v
                        },
                        expression: "skinName",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "filter-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        icon: "el-icon-search",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.getUserClickData("searchClick")
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small", icon: "el-icon-refresh" },
                      on: {
                        click: function ($event) {
                          return _vm.getUserClickData("reset")
                        },
                      },
                    },
                    [_vm._v("重置")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.userClickLoading,
                    expression: "userClickLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.userClickDataList,
                  stripe: "",
                  "header-cell-style": {
                    background: "#fafafa",
                    color: "#1a1a1a",
                    fontWeight: "600",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "urlId", label: "链接ID" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "urlName", label: "链接名" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "", label: "链接类型" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.transportShowType(scope.row.urlType)) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "skinId", label: "装修ID" },
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: { prop: "skinName", label: "装修页面" },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "totalDuration" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        {
                          staticClass: "sortable-header",
                          on: {
                            click: function ($event) {
                              return _vm.handleSort("totalDuration")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              停留时长（秒）\n              "
                          ),
                          _c("i", { staticClass: "sort-icons" }, [
                            _c("i", {
                              class: [
                                "el-icon-caret-top",
                                _vm.orderByType === "1" ? "active" : "",
                              ],
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                "el-icon-caret-bottom",
                                _vm.orderByType === "2" ? "active" : "",
                              ],
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "visitTimes" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        {
                          staticClass: "sortable-header",
                          on: {
                            click: function ($event) {
                              return _vm.handleSort("visitTimes")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              链接访问次数\n              "
                          ),
                          _c("i", { staticClass: "sort-icons" }, [
                            _c("i", {
                              class: [
                                "el-icon-caret-top",
                                _vm.orderByType === "3" ? "active" : "",
                              ],
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                "el-icon-caret-bottom",
                                _vm.orderByType === "4" ? "active" : "",
                              ],
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "visitUsers" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        {
                          staticClass: "sortable-header",
                          on: {
                            click: function ($event) {
                              return _vm.handleSort("visitUsers")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              链接访问人数\n              "
                          ),
                          _c("i", { staticClass: "sort-icons" }, [
                            _c("i", {
                              class: [
                                "el-icon-caret-top",
                                _vm.orderByType === "5" ? "active" : "",
                              ],
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                "el-icon-caret-bottom",
                                _vm.orderByType === "6" ? "active" : "",
                              ],
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 40],
                "page-size": _vm.userClickLimit,
                "current-page": _vm.userClickPage,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.userClickDataTotal,
              },
              on: {
                "size-change": _vm.handleSizeChange,
                "current-change": _vm.pageChange,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "chart-section" },
          [
            _c("div", { staticClass: "section-title" }, [
              _c("span", { staticClass: "title-text" }, [
                _vm._v("用户搜索分析"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "title-desc" }, [
                _vm._v("统计用户搜索关键词和搜索行为"),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.searchMsgLoading,
                    expression: "searchMsgLoading",
                  },
                ],
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.searchMsgDataList,
                  stripe: "",
                  "header-cell-style": {
                    background: "#fafafa",
                    color: "#1a1a1a",
                    fontWeight: "600",
                  },
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "keyword", label: "搜索内容" },
                }),
                _vm._v(" "),
                _c(
                  "el-table-column",
                  { attrs: { prop: "visitCount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        {
                          staticClass: "sortable-header",
                          on: {
                            click: function ($event) {
                              return _vm.handleSort2("visitCount")
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                搜索次数\n                "
                          ),
                          _c("i", { staticClass: "sort-icons" }, [
                            _c("i", {
                              class: [
                                "el-icon-caret-top",
                                _vm.orderByType2 === "1" ? "active" : "",
                              ],
                            }),
                            _vm._v(" "),
                            _c("i", {
                              class: [
                                "el-icon-caret-bottom",
                                _vm.orderByType2 === "2" ? "active" : "",
                              ],
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("el-pagination", {
              attrs: {
                "page-sizes": [10, 20, 30, 40],
                "page-size": _vm.searchMsgLimit,
                "current-page": _vm.searchMsgPage,
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.searchMsgDataTotal,
              },
              on: {
                "size-change": _vm.handleSizeChange2,
                "current-change": _vm.pageChange2,
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }